import { createContext } from "react";
import { toast } from "react-toastify";

export const ToasterContext = createContext(toast);
